import { SCartItemChangeHistoryDto } from "@/__generated__/sdk";
import { Box, Chip, Icon, Stack, Typography } from "@mui/material";
import { TYPES } from "@babel/types";
import TrendUpBoldIcon from "@/app/_components/Icons/TrendUpBoldIcon";
import TrendDownBoldIcon from "@/app/_components/Icons/TrendDownBoldIcon";
import BagCrossBoldIcon from "@/app/_components/Icons/BagCrossBoldIcon";
import ActivityBoldIcon from "@/app/_components/Icons/ActivityBoldIcon";
import ChartFailBoldIcon from "@/app/_components/Icons/ChartFailBoldIcon";
import ChartSuccessBoldIcon from "@/app/_components/Icons/ChartSuccessBoldIcon";
import Chart2BoldIcon from "@/app/_components/Icons/Chart2BoldIcon";

type Props = {
  history?: SCartItemChangeHistoryDto | null;
  dense?: boolean;
};
export default function CartItemHistory({ history, dense }: Props) {
  const down = "قیمت کالا {1} تومان کاهش پیدا کرده است.";
  const up = "قیمت کالا {1} تومان افزایش یافته است.";
  let list = [];
  if (!history) return <></>;

  if (history.oldQuantity !== null && history.newQuantity !== null) {
    if (history.newQuantity === 0) {
      list.push(
        <Box
          key={1}
          sx={{
            display: "flex",
            color: "error.main",
            backgroundColor: "error.light",
            borderRadius: 2,
            width: "max-content",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Icon fontSize={dense ? "small" : "medium"}>
            <BagCrossBoldIcon />
          </Icon>
          <Typography variant={dense ? "caption" : "body2"}>موجودی کالا به پایان رسیده است.</Typography>
        </Box>,
      );
    } else {
      list.push(
        <Box
          key={2}
          sx={{
            display: "flex",
            color: "info.main",
            backgroundColor: "info.light",
            borderRadius: 2,
            width: "max-content",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Icon fontSize={dense ? "small" : "medium"}>
            <ActivityBoldIcon />
          </Icon>
          <Typography variant={dense ? "caption" : "body2"}>موجودی کالا به {history.newQuantity} تغییر پیدا کرده است</Typography>
        </Box>,
      );
    }
  }

  if (history.oldOfferId !== null && history.newOfferId === null) {
    list.push(
      <Box
        sx={{
          display: "flex",
          color: "error.main",
          backgroundColor: "error.light",
          borderRadius: 2,
          width: "max-content",
          alignItems: "center",
          gap: 0.5,
        }}
        key={3}
      >
        <Icon fontSize={dense ? "small" : "medium"}>
          <ChartFailBoldIcon />
        </Icon>
        <Typography variant={dense ? "caption" : "body2"}>تخفیف به پایان رسید</Typography>
      </Box>,
    );
  } else if (history.oldOfferId === null && history.newOfferId !== null) {
    list.push(
      <Box
        sx={{
          display: "flex",
          color: "success.main",
          backgroundColor: "success.light",
          borderRadius: 2,
          width: "max-content",
          alignItems: "center",
          gap: 0.5,
        }}
        key={4}
      >
        <Icon fontSize={dense ? "small" : "medium"}>
          <ChartSuccessBoldIcon />
        </Icon>
        <Typography variant={dense ? "caption" : "body2"}>کالا تخفیف خورده است</Typography>
      </Box>,
    );
  }

  if (history.oldDiscountPrice !== history.newDiscountPrice) {
    list.push(
      <Box
        sx={{
          display: "flex",
          color: "warning.main",
          backgroundColor: "warning.light",
          borderRadius: 2,
          width: "max-content",
          alignItems: "center",
          gap: 0.5,
        }}
        key={5}
      >
        <Icon fontSize={dense ? "small" : "medium"}>
          <Chart2BoldIcon />
        </Icon>
        <Typography variant={dense ? "caption" : "body2"}>مقدار تخفیف تغییر کرده است.</Typography>
      </Box>,
    );
  }

  if (history.oldUnitPrice && history.newUnitPrice) {
    if (history.oldUnitPrice < history.newUnitPrice) {
      const def = history.newUnitPrice - history.oldUnitPrice;
      list.push(
        <Box
          sx={{
            display: "flex",
            color: "error.main",
            backgroundColor: "error.light",
            borderRadius: 2,
            width: "max-content",
            alignItems: "center",
            gap: 0.5,
          }}
          key={6}
        >
          <Icon fontSize={dense ? "small" : "medium"}>
            <TrendUpBoldIcon />
          </Icon>
          <Typography variant={dense ? "caption" : "body2"}>{up.replaceAll("{1}", def.toLocaleString())}</Typography>
        </Box>,
      );
    }
    if (history.oldUnitPrice > history.newUnitPrice) {
      const def = history.oldUnitPrice - history.newUnitPrice;

      list.push(
        <Box
          sx={{
            display: "flex",
            color: "success.main",
            backgroundColor: "success.light",
            borderRadius: 2,
            width: "max-content",
            alignItems: "center",
            gap: 0.5,
          }}
          key={7}
        >
          <Icon fontSize={dense ? "small" : "medium"}>
            <TrendDownBoldIcon />
          </Icon>
          <Typography variant={dense ? "caption" : "body2"}>{down.replaceAll("{1}", def.toLocaleString())}</Typography>
        </Box>,
      );
    }
  }
  if (history.available === false) {
    list = [
      <Box
        sx={{
          display: "flex",
          color: "error.main",
          backgroundColor: "error.light",
          borderRadius: 2,
          width: "max-content",
          alignItems: "center",
          gap: 0.5,
        }}
        key={8}
      >
        <Icon fontSize={dense ? "small" : "medium"}>
          <BagCrossBoldIcon />
        </Icon>
        <Typography variant={dense ? "caption" : "body2"}>کالا ناموجود شده است</Typography>
      </Box>,
    ];
  }
  return (
    <>
      <Stack spacing={1}>{list}</Stack>
    </>
  );
}
